import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html'
})
export class FilterComponent  {
  @Input() exibirBuscarPor: boolean = true;
}
